module.exports = __webpack_public_path__ + "static/Infographic4_4_Taichung_mobile-f332772a1bc427a4e4b3dac102599f9b.png";